const DEFAULT_DECIMAL_PLACES = 2;
const MAX_DECIMAL_PLACES = 2;

// Rates carry their own precision, separate from money, so that changing how
// many decimals amounts show can never alter a quoted rate. The ceiling is 4
// rather than 2 because the previous hardcoded behaviour was 3 decimals, which
// has to stay reachable from the admin panel without a deploy.
const DEFAULT_RATE_DECIMAL_PLACES = 1;
const MAX_RATE_DECIMAL_PLACES = 4;

let decimalPlaces = DEFAULT_DECIMAL_PLACES;
let rateDecimalPlaces = DEFAULT_RATE_DECIMAL_PLACES;

const parseDecimalPlaces = (value, max, fallback) => {
  const parsed = Number(value);
  const isValid = Number.isInteger(parsed) && parsed >= 0 && parsed <= max;

  return isValid ? parsed : fallback;
};

export const setDecimalPlaces = value => {
  decimalPlaces = parseDecimalPlaces(
    value,
    MAX_DECIMAL_PLACES,
    DEFAULT_DECIMAL_PLACES
  );
};

export const getDecimalPlaces = () => decimalPlaces;

export const setRateDecimalPlaces = value => {
  rateDecimalPlaces = parseDecimalPlaces(
    value,
    MAX_RATE_DECIMAL_PLACES,
    DEFAULT_RATE_DECIMAL_PLACES
  );
};

export const getRateDecimalPlaces = () => rateDecimalPlaces;

export const formatRate = (value, decimals = rateDecimalPlaces) =>
  (Number(value) || 0).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });

export const formatAmount = (value, decimals = decimalPlaces) =>
  (Number(value) || 0).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });

export const formatAmountWithDecimals = (value, decimals = decimalPlaces) =>
  (Number(value) || 0).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
export const formatNegativeAmount = value => {
  return value > 0
    ? `(${formatAmount(Number(value))})`
    : formatAmount(Math.abs(Number(value)));
};

export const formatPositiveAmount = value => {
  return Number(value) < 0
    ? `(${formatAmount(Math.abs(Number(value)))})`
    : formatAmount(Number(value));
};

export const formatCurrencyWithDecimals = (value, decimals = decimalPlaces) => {
  return `$${formatAmountWithDecimals(value, decimals)}`;
};

export const removesScientificNotationFromNumber = value => {
  if (typeof value === 'number') {
    if (value.toString().includes('e')) {
      return Number(value)
        .toFixed(16)
        .replace(/\.?0+$/, '');
    }

    return Number(value).toString();
  }

  return value;
};
